import React from 'react'
import { Box, CssBaseline } from '@mui/material'
import Footer from 'src/components/Footer'
import Header from 'src/components/Header'

interface ILayoutProps {
  children: React.ReactNode
}

const BaseLayout: React.FC<ILayoutProps> = ({ children }) => {
  return (
    <Box sx={{ backgroundColor: 'bw.white' }}>
      <CssBaseline />
      <Header />
      {children}
      <Footer />
    </Box>
  )
}

export default BaseLayout
